export const getAllDeliveryAreasData = ({ state }) => state.deliveryAreas.deliveryAreasData;

export const getSelectedAreaData = ({ state }) => state.deliveryAreas.selectedArea;

export const getSubAreasData = ({ state }) => state.deliveryAreas.subAreasData;

export const getSelectedSubAreaData = ({ state }) => state.deliveryAreas.selectedSubArea;

export const getAllMainAreasData = ({ state }) => state.deliveryAreas.mainAreas;
